import React, { Component } from 'react';

class Banner extends Component {
    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';
        let backgroundImageUrl = publicUrl + 'assets/img/banner/fundo-home.webp';

        return (
            <div className="banner-area modern-hero-banner viaje-go-top">
                
                {/* CSS ATUALIZADO - CORREÇÃO DO BOTÃO */}
                <style>{`
                    .modern-hero-banner {
                        position: relative;
                        background-image: url(${backgroundImageUrl});
                        background-size: cover;
                        background-position: center center;
                        min-height: 100vh; 
                        display: flex;
                        align-items: center;
                        overflow: hidden;
                    }

                    .modern-hero-banner::before {
                        content: '';
                        position: absolute;
                        top: 0; left: 0; right: 0; bottom: 0;
                        background: rgba(0, 0, 0, 0.6); 
                        z-index: 1;
                    }

                    .modern-hero-banner .container {
                        position: relative;
                        z-index: 2;
                    }

                    .modern-sub-title {
                        display: block;
                        color: #D1AD69;
                        font-size: 20px;
                        font-weight: 600;
                        letter-spacing: 2px;
                        text-transform: uppercase;
                        margin-bottom: 20px;
                    }

                    .modern-title {
                        color: #ffffff;
                        font-size: 60px;
                        font-weight: 800;
                        line-height: 1.1;
                        margin-bottom: 30px;
                    }

                    .modern-text {
                        color: #e0e0e0;
                        font-size: 20px;
                        line-height: 1.6;
                        margin-bottom: 40px;
                        max-width: 800px;
                        margin-left: auto;
                        margin-right: auto;
                    }

                    /* --- CORREÇÃO DO BOTÃO --- */
                    .btn-whatsapp-hero {
                        background-color: #25D366;
                        border: none;
                        
                        /* Isso aqui centraliza o texto perfeitamente no meio */
                        display: inline-flex !important; 
                        align-items: center;
                        justify-content: center;
                        
                        /* Reseta a altura fixa do tema para o padding funcionar */
                        height: auto !important; 
                        line-height: 1.2 !important;
                        
                        padding: 15px 40px !important;
                        font-size: 18px;
                        font-weight: 700;
                        border-radius: 50px;
                        box-shadow: 0 10px 20px rgba(37, 211, 102, 0.3);
                        transition: all 0.3s ease;
                        
                        /* Garante que o botão não fique largura total */
                        width: auto !important;
                        max-width: 100%;
                    }
                    
                    .btn-whatsapp-hero:hover {
                        background-color: #1da851;
                        transform: translateY(-3px);
                        color: #fff;
                    }

                    @media (max-width: 768px) {
                        .modern-title {
                            font-size: 36px;
                        }
                        .modern-sub-title {
                            font-size: 14px;
                            letter-spacing: 1px;
                        }
                        .modern-text {
                            font-size: 16px;
                        }
                        /* No celular, o botão pode ser um pouco menor, mas centralizado */
                        .btn-whatsapp-hero {
                            padding: 15px 25px !important;
                            font-size: 16px;
                            width: auto !important; 
                        }
                        .banner-social-meta {
                            display: none;
                        }
                    }
                `}</style>

                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 text-center">
                            <div className="banner-content">
                                
                                <span className="modern-sub-title">
                                    Por um casal que ama viajar e vai te fazer amar também
                                </span>

                                <h1 className="modern-title">
                                    A gente cuida de tudo para sua viagem perfeita.
                                </h1>

                                <p className="modern-text">
                                    Passagens, hospedagem, roteiro e suporte. Descobrimos que o que realmente importa não é apenas o destino, mas como você vive cada momento.
                                </p>

                                <div className="banner-btn">
                                    <a href="https://wa.me/5511930766388" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-whatsapp-hero">
                                        <i className="fa fa-whatsapp" style={{ marginRight: '10px', fontSize: '22px' }}></i>
                                        Quero planejar minha viagem
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="banner-social-meta">
                    <ul className="social-icon">
                        <li>
                            <a className="pinterest" href="https://www.instagram.com/flutuaragencia?igsh=MXZvejVweDBrdTQ0Ng==" target="_blank" rel="noreferrer" style={{ color: '#fff' }}>
                                <i className="fa fa-instagram" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Banner;